// document.addEventListener('DOMContentLoaded', function () {
  
//   localStorage.clear();
//   const SITE_ID = '5op9sn';
//   const SECTION_ID = 'search-grid-2';
//   const CACHE_DURATION_MINUTES = 5;
//   const RESULTS_PER_PAGE = 9;

//   const pathParts = window.location.pathname.split('/').filter(Boolean);
//   const isCollectionPage = pathParts.includes('collections');
//   const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
//   if (!isCollectionPage || !collectionHandle) return;

//   const productGrid = document.querySelector('#product-grid-2');
//   if (!productGrid) {
//     console.warn('❗ #product-grid-2 not found — cannot render collection products.');
//     return;
//   }

//   const shopifyRoot = Shopify?.routes?.root || '/';
//   let currentPage = 1;
//   let isFetching = false;
//   let hasMorePages = true;

//   // --- Active State ---
//   var activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; // e.g. { color: ['Blue', 'Green'], size: ['M'] }
//   var activeSort = ''; // e.g. 'price:asc'
//   window.toggleFilter = toggleFilter; // call with toggleFilter('color', 'Blue')
//   window.applySort = applySort; // call with applySort('price', 'asc')
//   window.applyFilter = applyFilter; 
//   // ========================
//   // APPLY URL SORT ON PAGE LOAD
//   // ========================
//   const urlParams = new URLSearchParams(window.location.search);
//   const sortParam = urlParams.get('sort_by');
// // 1️⃣ Handle filters from URL (product_type, variant_size, tags_colour, tags_fabric)
// ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
//   const values = urlParams.getAll(key);
//   if (values.length > 0) {
//     if (!activeFilters[key]) activeFilters[key] = [];
//     values.forEach(v => {
//       activeFilters[key].push(v);
//     });
//   }
// });

//   if (sortParam) {
//     let field = '';
//     let direction = '';

//     switch (sortParam) {
//       case 'manual':
//         field = 'featured';
//         direction = 'desc';
//         break;
//       case 'title-ascending':
//         field = 'title';
//         direction = 'asc';
//         break;
//       case 'title-descending':
//         field = 'title';
//         direction = 'desc';
//         break;
//       case 'price-ascending':
//         field = 'ss_price';
//         direction = 'asc';
//         break;
//       case 'price-descending':
//         field = 'ss_price';
//         direction = 'desc';
//         break;
//       default:
//         field = 'featured';
//         direction = 'desc';
//     }

//     const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
//     if (radioInput) {
//       radioInput.checked = true;
//     }

//     activeSort = `${field}:${direction}`
//     // console.log(`[Collection] Applied sort from URL: ${sortParam} (${field}:${direction})`);
//   }

//   function toggleFilter(type, value) {
//     if (!activeFilters[type]) activeFilters[type] = [];
//     const index = activeFilters[type].indexOf(value);
//     if (index > -1) {
//       activeFilters[type].splice(index, 1);
//       if (activeFilters[type].length === 0) delete activeFilters[type];
//     } else {
//       activeFilters[type].push(value);
//     }
//     resetCollection();
//   }

//   function applySort(field, direction) {
//     activeSort = `${field}:${direction}`;
//     resetCollection();
//   }
//   function renderSearchspringFilters(facets) {
//   // console.log('facets', facets);
//   const filterContainer = document.querySelector('.filter-wrap');
//   if (!filterContainer) return;

//   // Clear existing filters
//   filterContainer.innerHTML = '';

//   facets.forEach(facet => {
//     // ❌ Skip price or range-type filters
//     if (
//       facet.field === 'ss_price' ||
//       facet.label?.toLowerCase().includes('price') ||
//       facet.type === 'range'
//     ) {
//       return;
//     }

//     // Skip if no values
//     if (!facet.values || facet.values.length === 0) return;

//     // Create facet wrapper with theme classes
//     const facetWrap = document.createElement('div');
//     facetWrap.className = 'facet-list filter-inr filter-index';
//     facetWrap.innerHTML = `
//       <div class="filter-title">
//         <span>${facet.label}</span>
//         <span>
//           <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
//             <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
//           </svg>
//         </span>
//       </div>
//       <ul class="filter-inr-wrap"></ul>
//     `;

//     const list = facetWrap.querySelector('.filter-inr-wrap');

//     // Loop through facet values
//     facet.values.forEach(v => {
//       const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
//       const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
//       const isChecked =
//         activeFilters[facet.field] &&
//         activeFilters[facet.field].includes(val);

//       const li = document.createElement('li');
//       li.innerHTML = `
//         <input class="facet-input"
//               type="checkbox"
//               id="${safeId}"
//               name="${facet.field}"
//               value="${val}"
//               ${isChecked ? 'checked' : ''}
//               onchange="toggleFilter('${facet.field}', '${val}')">
//         <label for="${safeId}">${v.label || val}</label>
//       `;
//       list.appendChild(li);
//     });

//     // Append the whole facet block
//     filterContainer.appendChild(facetWrap);
    
//     if (typeof filter_acco == 'function'){
//       filter_acco();
//     }
//     document.querySelectorAll('.filter-title').forEach(function(self){
//         self.addEventListener('click', function(event){
//             self.closest('.filter-index').classList.toggle('active');
//             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//         })
//     });
//     // document.querySelectorAll('.filter-title').forEach(function(self){
//     //     self.addEventListener('click', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     });
//     //     self.addEventListener('ontouchend', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     })
//     // });
//   });
// }
//   function applyFilter() {
//     activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; 
//     setTimeout(function(){
//       document.querySelectorAll('.wc_filter_option:checked').forEach(function(self){
//         var field_value = self.getAttribute('data-param-name');
//         if (field_value.includes('product_type')) {
//           activeFilters.product_type.push(self.value);
//         }
//         if (field_value.includes('filter.v.option.size')) {
//           activeFilters.variant_size.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.color')) {
//           activeFilters.tags_colour.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.fabric')) {
//           activeFilters.tags_fabric.push(self.value);
//         }
//       });
//       resetCollection();
//     }, 500);
//   }

//   function buildSearchspringParams() {
//     let params = [];

//     // Add filters
//     Object.entries(activeFilters).forEach(([key, values]) => {
//       values.forEach(val => {
//         params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
//       });
//     });

//     // Add sorting
//     if (activeSort) {
//       const [field, dir] = activeSort.split(':');
//       params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
//     }

//     return params.join('&');
//   }

//   // ========================
//   // LOCAL CACHE HANDLERS
//   // ========================

//   function getCachedProduct(handle) {
//     const cacheKey = `product_html_${handle}`;
//     const cached = localStorage.getItem(cacheKey);
//     if (!cached) return null;
//     const parsed = JSON.parse(cached);
//     const now = Date.now();
//     if (now - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
//       return parsed.html;
//     } else {
//       localStorage.removeItem(cacheKey);
//       return null;
//     }
//   }

//   function setCachedProduct(handle, html) {
//     const cacheKey = `product_html_${handle}`;
//     localStorage.setItem(
//       cacheKey,
//       JSON.stringify({ timestamp: Date.now(), html })
//     );
//   }

//   // ========================
//   // COLLECTION FETCH LOGIC
//   // ========================

//   async function fetchCollectionPage(page = 1) {
//     // console.log('page collection loaded');
//     if (isFetching || !hasMorePages) return;
//     isFetching = true;

//     const loader = document.querySelector('.look-cart-loader-inner');
//     if (loader) loader.style.display = 'flex';

//     try {
//       const extraParams = buildSearchspringParams();
//       const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${
//         extraParams ? '&' + extraParams : ''
//       }`;

//       const response = await fetch(apiURL);
//       const data = await response.json();
//       if (page === 1 && data.facets) {
//         renderSearchspringFilters(data.facets);
//       }
//       if (!data.results || data.results.length === 0) {
//         if (page === 1) productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
//         hasMorePages = false;
//         return;
//       }

//       const handles = data.results.map(p => p.handle).filter(Boolean);
//       const sectionPromises = handles.map(async (handle, index) => {
//       const cachedHTML = getCachedProduct(handle);
//       if (cachedHTML) return { index, html: cachedHTML, handle };

//       try {
//         const res = await fetch(`${shopifyRoot}products/${handle}?sections=${SECTION_ID}`);
//         const json = await res.json();
//         const html = json?.[SECTION_ID];

//         if (!html) {
//           const productData = data.results[index];
//           const fallbackHTML = `
//             <div class="fallback-product">
//               <a href="${shopifyRoot}products/${productData.handle}">
//                 <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
//                 <h3>${productData.name || ''}</h3>
//                 <p>${productData.price || ''}</p>
//               </a>
//             </div>`;
//           setCachedProduct(handle, fallbackHTML);
//           return { index, html: fallbackHTML, handle };
//         }

//         setCachedProduct(handle, html);
//         if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
//           return { index: ``, html: ``, handle: `` };
//         }else{
//           return { index, html, handle };
//         }
//       } catch (err) {
//         console.warn(`❌ Section fetch failed: ${handle}`, err);
//         return { index, html: ``, handle };
//       }
//     });

//       const sections = await Promise.all(sectionPromises);
//       sections.sort((a, b) => a.index - b.index);
//       const validSections = sections.filter(s => s.html && s.html.trim() !== '');
//       const combinedHTML = validSections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');

//       if (combinedHTML.trim() !== '') {
//         productGrid.insertAdjacentHTML('beforeend', combinedHTML);
//       } else {
//         console.warn('⚠️ No valid product HTML found to insert.');
//       }
//       // const combinedHTML = sections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');
//       // productGrid.insertAdjacentHTML('beforeend', combinedHTML);

//       $th_refreshWishlistItems?.();
//       quickAddButton2();
//       colorVariantClick2();
      
//       // console.log(`[Collection] Rendered page ${page} (${sections.length} products)`);
//       document.querySelector('.collection-grid.placeholder-grid').style.display = 'none';
//       if (data.pagination.currentPage == data.pagination.totalPages) {
//         document.querySelector('#AjaxinatePagination').style.display = 'none';
//       }
//       if (!data.pagination?.nextPage) hasMorePages = false;
//       currentPage++;
//     } catch (err) {
//       // console.error('❌ Error fetching collection products:', err);
//       if (currentPage === 1) {
//         productGrid.innerHTML = ``;
//       }
//     } finally {
//       isFetching = false;
//       if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
//     }
//   }

//   // ========================
//   // PAGINATION / SCROLL
//   // ========================
//   window.addEventListener('scroll', () => {
//     if (isFetching || !hasMorePages) return;
//     const scrollY = window.scrollY + window.innerHeight;
//     const threshold = document.body.offsetHeight - 1000;
//     if (scrollY >= threshold) fetchCollectionPage(currentPage);
//   });

//   function resetCollection() {
//     // console.log('reset called');
//     productGrid.innerHTML = '';
//     currentPage = 1;
//     hasMorePages = true;
//     fetchCollectionPage(currentPage);
//   }

//   // ========================
//   // INITIAL LOAD
//   // ========================
//   fetchCollectionPage(currentPage);

//   // ========================
//   // QUICK ADD + COLOR VARIANT
//   // ========================
//   function quickAddButton2() {
//     document.querySelectorAll('.variant-grid').forEach(sizeList => {
//       sizeList.addEventListener('click', e => {
//         e.preventDefault();
//         const variant_id = sizeList.dataset.id;
//         const formData = { items: [{ id: variant_id, quantity: 1 }] };
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(formData),
//         })
//           .then(r => r.json())
//           .then(() => {
//             if (typeof load_cart === 'function') load_cart();
//           })
//           .catch(console.error);
//       });
//     });
//   }

//   function colorVariantClick2() {
//     if (window.innerWidth > 1024) {
//       document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
//         element.addEventListener('click', function (event) {
//           event.preventDefault();
//           const attVal = this.getAttribute('data-id');
//           const productItem = this.closest('.product-item');
//           if (!productItem) return;

//           const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
//           innerGrids.forEach(function (innerGrid) {
//             if (attVal === innerGrid.getAttribute('data-id')) {
//               innerGrids.forEach(g => g.classList.remove('active'));
//               innerGrid.classList.add('active');
//             }
//           });
//         });
//       });
//     }
//   }
// });

// //  document.querySelectorAll('.filter-title').forEach(function(self){
// //         self.addEventListener(['ontouchend', 'click'], function(event){
// //             self.closest('.filter-index').classList.toggle('active');
// //             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
// //         })
// //     });

// // if (window.innerWidth < 1224) {
// //   filter_acco();
// // }






document.addEventListener('DOMContentLoaded', function () {

  const SITE_ID = '3140wd';
  const SECTION_ID = 'search-grid-2';
  const CACHE_DURATION_MINUTES = 5;
  const RESULTS_PER_PAGE = 9;

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const isCollectionPage = pathParts.includes('collections');
  const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
  if (!isCollectionPage || !collectionHandle) return;

  const productGrid = document.querySelector('#product-grid-2');
  if (!productGrid) {
    console.warn('❗ #product-grid-2 not found — cannot render collection products.');
    return;
  }

  const shopifyRoot = Shopify?.routes?.root || '/';
  let currentPage = 1;
  let isFetching = false;
  let hasMorePages = true;

  var activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
  var activeSort = '';

  window.toggleFilter = toggleFilter;
  window.applySort = applySort;
  window.applyFilter = applyFilter;

  // ========================
  // APPLY URL SORT ON PAGE LOAD
  // ========================
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort_by');

  ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
    const values = urlParams.getAll(key);
    if (values.length > 0) {
      if (!activeFilters[key]) activeFilters[key] = [];
      values.forEach(v => {
        activeFilters[key].push(v);
      });
    }
  });

  if (sortParam) {
    let field = '';
    let direction = '';

    switch (sortParam) {
      case 'manual':
        field = 'featured'; direction = 'desc'; break;
      case 'title-ascending':
        field = 'title'; direction = 'asc'; break;
      case 'title-descending':
        field = 'title'; direction = 'desc'; break;
      case 'price-ascending':
        field = 'ss_price'; direction = 'asc'; break;
      case 'price-descending':
        field = 'ss_price'; direction = 'desc'; break;
      default:
        field = 'featured'; direction = 'desc';
    }

    const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
    if (radioInput) radioInput.checked = true;
    activeSort = `${field}:${direction}`;
  }

  function toggleFilter(type, value) {
    if (!activeFilters[type]) activeFilters[type] = [];
    const index = activeFilters[type].indexOf(value);
    if (index > -1) {
      activeFilters[type].splice(index, 1);
      if (activeFilters[type].length === 0) delete activeFilters[type];
    } else {
      activeFilters[type].push(value);
    }
    resetCollection();
  }

  function applySort(field, direction) {
    activeSort = `${field}:${direction}`;
    resetCollection();
  }

  function applyFilter() {
    activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
    setTimeout(function () {
      document.querySelectorAll('.wc_filter_option:checked').forEach(function (self) {
        var field_value = self.getAttribute('data-param-name') || '';
        if (field_value.includes('product_type')) activeFilters.product_type.push(self.value);
        if (field_value.includes('filter.v.option.size')) activeFilters.variant_size.push(self.value);
        if (field_value.includes('filter.p.m.custom.color')) activeFilters.tags_colour.push(self.value);
        if (field_value.includes('filter.p.m.custom.fabric')) activeFilters.tags_fabric.push(self.value);
      });
      resetCollection();
    }, 500);
  }

  function buildSearchspringParams() {
    let params = [];
    Object.entries(activeFilters).forEach(([key, values]) => {
      values.forEach(val => {
        params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      });
    });
    if (activeSort) {
      const [field, dir] = activeSort.split(':');
      params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
    }
    return params.join('&');
  }

  // ========================
  // LOCAL PRODUCT CACHE
  // ========================
  function getCachedProduct(handle) {
    const cacheKey = `product_html_${handle}`;
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;
    try {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
        return parsed.html;
      } else {
        localStorage.removeItem(cacheKey);
        return null;
      }
    } catch (e) { localStorage.removeItem(cacheKey); return null; }
  }

  function setCachedProduct(handle, html) {
    const cacheKey = `product_html_${handle}`;
    try { localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), html })); }
    catch (e) {}
  }

  // ========================
  // FETCH COLLECTION
  // ========================
  async function fetchCollectionPage(page = 1) {
    if (isFetching || !hasMorePages) return;
    isFetching = true;

    const loader = document.querySelector('.look-cart-loader-inner');
    if (loader) loader.style.display = 'flex';

    try {
      const extraParams = buildSearchspringParams();
      const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${extraParams ? '&' + extraParams : ''}`;
      const response = await fetch(apiURL);
      if (!response.ok) throw new Error('Searchspring API error');
      const data = await response.json();

      if (page === 1 && data.facets) {
        renderSearchspringFilters(data.facets);
        sessionStorage.setItem(`collection_facets_${collectionHandle}`, JSON.stringify(data.facets));
        setTimeout(() => {
          if (typeof filter_accod === 'function') filter_accod();
          if (typeof ensureGridImagesUpdate === 'function') ensureGridImagesUpdate();
        }, 300);
      }

      if (!data.results || data.results.length === 0) {
        if (page === 1) productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
        hasMorePages = false;
        return;
      }

      const handles = data.results.map(p => p.handle).filter(Boolean);
      const sectionPromises = handles.map(async (handle, index) => {
        const cachedHTML = getCachedProduct(handle);
        if (cachedHTML) return { index, html: cachedHTML, handle };

        try {
          const res = await fetch(`${shopifyRoot}products/${handle}?sections=${SECTION_ID}`);
          if (!res.ok) throw new Error('Shopify section fetch failed');
          const json = await res.json();
          const html = json?.[SECTION_ID] || '';

          if (!html || html.trim() === '') {
            const productData = data.results[index] || {};
            const fallbackHTML = `
              <div class="fallback-product">
                <a href="${shopifyRoot}products/${productData.handle}">
                  <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
                  <h3>${productData.name || ''}</h3>
                  <p>${productData.price || ''}</p>
                </a>
              </div>`;
            setCachedProduct(handle, fallbackHTML);
            return { index, html: fallbackHTML, handle };
          }

          setCachedProduct(handle, html);
          return { index, html, handle };
        } catch (err) {
          console.warn(`❌ Section fetch failed: ${handle}`, err);
          return { index, html: `<div class="error">Failed to load ${handle}</div>`, handle };
        }
      });

      const sections = await Promise.all(sectionPromises);
      sections.sort((a, b) => (a.index - b.index));
      const validSections = sections.filter(s => s.html && s.html.trim() !== '');
      const combinedHTML = validSections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');

      if (combinedHTML.trim() !== '') productGrid.insertAdjacentHTML('beforeend', combinedHTML);
      if (typeof $th_refreshWishlistItems === 'function') $th_refreshWishlistItems();
      quickAddButton2(); colorVariantClick2();

      document.querySelector('.collection-grid.placeholder-grid')?.style?.setProperty('display', 'none');
      if (data.pagination?.currentPage == data.pagination?.totalPages) document.querySelector('#AjaxinatePagination')?.style?.setProperty('display', 'none');
      if (!data.pagination?.nextPage) hasMorePages = false;
      currentPage++;
    } catch (err) {
      console.warn('Error fetching collection page:', err);
      if (currentPage === 1) productGrid.innerHTML = `<div class="error">Error loading products.</div>`;
    } finally {
      isFetching = false;
      if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
    }
  }

  // ========================
  // RENDER FILTERS
  // ========================
  function renderSearchspringFilters(facets) {
    const filterContainer = document.querySelector('.filter-wrap');
    const filterBtnsContainer = document.querySelector('.special-filters');
    console.log('filterBtnsContainer +++++', filterBtnsContainer);

    if (!filterContainer) return;
    filterContainer.innerHTML = '';

    if (filterBtnsContainer) filterBtnsContainer.querySelectorAll('.facet-list').forEach(el => el.remove());

    facets.forEach(facet => {
      if (facet.field === 'ss_price' || facet.label?.toLowerCase().includes('price') || facet.type === 'range') return;
      if (!facet.values || facet.values.length === 0) return;

      const facetWrap = document.createElement('div');
      facetWrap.className = 'facet-list filter-inr filter-index';
      facetWrap.innerHTML = `
        <div class="filter-title">
          <span>${facet.label}</span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
              <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
            </svg>
          </span>
        </div>
        <ul class="filter-inr-wrap"></ul>
      `;
      const list = facetWrap.querySelector('.filter-inr-wrap');

      let values = facet.values;
      if (facet.field === 'variant_size') {
        const sizeOrder = ['XXS','XS','S','M','L','XL','XXL','XXXL','OS'];
        const alphaSizes = [], numericSizes = [], others = [];
        values.forEach(v => {
          const val = (v.value||v.label||'').toUpperCase().trim();
          if (sizeOrder.includes(val)) alphaSizes.push(v);
          else if (/^[0-9]+$/.test(val)) numericSizes.push(v);
          else others.push(v);
        });
        alphaSizes.sort((a,b)=>sizeOrder.indexOf((a.value||a.label).toUpperCase())-sizeOrder.indexOf((b.value||b.label).toUpperCase()));
        numericSizes.sort((a,b)=>parseInt(a.value)-parseInt(b.value));
        others.sort((a,b)=>(a.label||'').localeCompare(b.label||''));
        values = [...alphaSizes,...numericSizes,...others];
      }

      values.forEach(v => {
        const val = v.value||v.label||`${v.low}-${v.high}`||'unknown';
        const safeId = `${facet.field}-${String(val).replace(/\s+/g,'-').toLowerCase()}`;
        const isChecked = activeFilters[facet.field]?.includes(val);
        const li = document.createElement('li');
        li.innerHTML = `
          <input class="facet-input" type="checkbox" id="${safeId}" name="${facet.field}" value="${val}" ${isChecked?'checked':''} onchange="toggleFilter('${facet.field}','${val}')">
          <label for="${safeId}">${v.label||val}</label>
        `;
        list.appendChild(li);
      });

      if ((facet.label||'').toLowerCase().trim() === 'product type') {
        if (filterBtnsContainer) filterBtnsContainer.appendChild(facetWrap);
        else filterContainer.appendChild(facetWrap);
      } else filterContainer.appendChild(facetWrap);
    });
  }

  // ========================
  // RESTORE PAGE CACHE
  // ========================
  const cacheKey = `collection_cache_${collectionHandle}`;
  const cachedState = sessionStorage.getItem(cacheKey);

  if (cachedState) {
    try {
      const { html, scrollY, page, timestamp } = JSON.parse(cachedState);
      const isFresh = Date.now() - timestamp < 10*60*1000;

      if (isFresh && html) {
        productGrid.innerHTML = html;
        currentPage = page;
        hasMorePages = true;
        isFetching = false;
        setTimeout(()=>window.scrollTo(0, scrollY||0),50);

        const cachedFacets = JSON.parse(sessionStorage.getItem(`collection_facets_${collectionHandle}`));
        if (cachedFacets) renderSearchspringFilters(cachedFacets);

        console.log('Restored collection grid from cache — skipping fetch');
      } else {
        sessionStorage.removeItem(cacheKey);
        fetchCollectionPage(currentPage);
      }
    } catch (err) { console.warn('Cache restore failed', err); fetchCollectionPage(currentPage); }
  } else fetchCollectionPage(currentPage);

  const savePageCache = () => {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({
        html: productGrid.innerHTML,
        scrollY: window.scrollY,
        page: currentPage,
        timestamp: Date.now(),
      }));
    } catch(e){}
  };

  const observer = new MutationObserver(savePageCache);
  observer.observe(productGrid, { childList:true, subtree:true });

  document.addEventListener('click', e => {
    const link = e.target.closest('a[href*="/products/"]');
    if (link) savePageCache();
  });
  window.addEventListener('beforeunload', savePageCache);
  window.addEventListener('scroll', () => {
    if (isFetching || !hasMorePages) return;
    const scrollY = window.scrollY + window.innerHeight;
    const threshold = document.body.offsetHeight - 1000;
    if (scrollY >= threshold) fetchCollectionPage(currentPage);
  });

  function resetCollection() {
    productGrid.innerHTML = '';
    currentPage = 1;
    hasMorePages = true;
    fetchCollectionPage(currentPage);
  }

  function quickAddButton2() {
    document.querySelectorAll('.variant-grid').forEach(sizeList => {
      sizeList.replaceWith(sizeList.cloneNode(true));
    });
    document.querySelectorAll('.variant-grid').forEach(sizeList => {
      sizeList.addEventListener('click', e => {
        e.preventDefault();
        const variant_id = sizeList.dataset.id;
        if (!variant_id) return;
        const formData = { items:[{id:variant_id,quantity:1}] };
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify(formData)
        }).then(r=>r.json()).then(()=>{
          if(typeof load_cart=='function'){
            load_cart();
            setTimeout(()=>document.querySelector('body').classList.add('open-drawer'),2000);
          } else window.location.href="/cart";
        }).catch(console.error);
      });
    });
  }

  function colorVariantClick2() {
    document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(el=>{
      const clone=el.cloneNode(true); el.parentNode.replaceChild(clone,el);
    });

    if(window.innerWidth>1024){
      document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function(element){
        element.addEventListener('click', function(event){
          event.preventDefault();
          const attVal=this.getAttribute('data-id');
          const productItem=this.closest('.product-item');
          if(!productItem)return;
          const innerGrids=productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
          innerGrids.forEach(function(innerGrid){
            if(attVal===innerGrid.getAttribute('data-id')){
              innerGrids.forEach(g=>g.classList.remove('active'));
              innerGrid.classList.add('active');
            }
          });
        });
      });
    }
  }

  setTimeout(()=>{
    if(document.querySelector('#product-grid-2')?.children.length) document.querySelectorAll('.placeholder-grid').forEach(el=>el.style.display='none');
  },500);

});
